import { React, useRef } from "react";
import classes from "./AddToCart.module.scss";
import Counter from "./Counter/Counter";

function AddToCartB({
  id,
  imageURL,
  productName,
  description,
  price,
  addItem,
  cart,
  product,
  updateQuantity,
  quantity,
  increment,
  decrement,
  speakerZX7increment,
  speakerZX7decrement,
  speakerZX7quantity,
  speakerZX9increment,
  speakerZX9decrement,
  speakerZX9quantity,
  earphoneDetailincrement,
  earphoneDetaildecrement,
  earphoneDetailQuantity,
  markOneIncrement,
  markOneDecrement,
  markOneQuantity,
  markTwoDecrement,
  markTwoQuantity,
  xx59Increment,
  xx59Decrement,
  xx59Quantity,
}) {
  const formattedPrice = Number(price).toLocaleString();

  return (
    <section className={`${classes.product_container} ${classes.container}`}>
      <img src={imageURL} alt="" className={classes.product_img} />
      <div className={classes.product_description}>
        <div className={classes.product_description_content}>
          <h1 className={classes.product_name}>{productName}</h1>
          <p className={classes.product_text}>{description}</p>
          <p className={classes.price}>{`$${formattedPrice}`}</p>
          <Counter
            addProductToCart={addItem}
            id={id}
            cart={cart}
            updateQuantity={updateQuantity}
            product={product}
            quantity={quantity}
            increment={increment}
            decrement={decrement}
          />
        </div>
      </div>
    </section>
  );
}

export default AddToCartB;
